import sectionCardVideoSliderCss from '../css-snippets/section-card-video-slider';

const html = `
<style>${sectionCardVideoSliderCss}</style>
<div id="card-container-unique-id" data-attribute="card-container" data-id="unique-id" data-background="#FFFFFF"
  data-top-padding="true" data-bottom-padding="true" style="background-color: rgb(255, 255, 255);">
  <div class="container-page" data-attribute="container-page" data-show-style="true" data-background="#FFFFFF"
    style="background-color: transparent;">
    <div class="wrap-card container">
      <div data-attribute="card-header" data-show="true" class="card-header" style="display: block;">
        <h2 style="text-align:center;">Lorem ipsum dolor sit amet consectetur&nbsp;</h2>
        <p style="text-align:center;">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Quidem qui fuga ipsa,
          temporibus quas nostrum cupiditate numquam assumenda excepturi eaque aperiam a.&nbsp;</p>
      </div>
      <div class="swiper swiper-video-unique-id">
        <div data-attribute="list-item" class="swiper-wrapper" data-auto-play-video="false" data-muted="false" data-bg-play-video="#d4c4a8"
          data-color-play-video="#FFFFFF">
          <div data-attribute="item" class="swiper-slide">
            <div class="wrap-item">
              <video loop playsinline width="600">
                <source data-attribute="card-video"
                  src="https://hizoo.co/cdn/shop/videos/c/vp/e1cad5ac90d64cc9ae31a3f1efcc6915/e1cad5ac90d64cc9ae31a3f1efcc6915.HD-720p-1.6Mbps-57703554.mp4?v=0"
                  type="video/mp4">
              </video>
              <div data-attribute="playvideo" data-background="#d4c4a8" data-color="#FFFFFF"
                style="background-color: #d4c4a8; color: #FFFFFF;" class="playvideo">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="lucide lucide-play-icon lucide-play">
                  <path d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z" />
                </svg>
              </div>
              <div class="volume">
                <span class="volume-icon" style="display: flex;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-volume2-icon lucide-volume-2">
                    <path
                      d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z" />
                    <path d="M16 9a5 5 0 0 1 0 6" />
                    <path d="M19.364 18.364a9 9 0 0 0 0-12.728" />
                  </svg>
                </span>
                <span class="mute-icon" style="display: none;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-volume-off-icon lucide-volume-off">
                    <path d="M16 9a5 5 0 0 1 .95 2.293" />
                    <path d="M19.364 5.636a9 9 0 0 1 1.889 9.96" />
                    <path d="m2 2 20 20" />
                    <path
                      d="m7 7-.587.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298V11" />
                    <path d="M9.828 4.172A.686.686 0 0 1 11 4.657v.686" />
                  </svg>
                </span>
              </div>
            </div>
          </div>
          <div data-attribute="item" class="swiper-slide">
            <div class="wrap-item">
              <video loop playsinline width="600">
                <source data-attribute="card-video"
                  src="https://hizoo.co/cdn/shop/videos/c/vp/615818a67cff451d9f6f1d121b368cd6/615818a67cff451d9f6f1d121b368cd6.HD-1080p-2.5Mbps-57703597.mp4?v=0"
                  type="video/mp4">
              </video>
              <div data-attribute="playvideo" data-background="#d4c4a8" data-color="#FFFFFF"
                style="background-color: #d4c4a8; color: #FFFFFF;" class="playvideo">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="lucide lucide-play-icon lucide-play">
                  <path d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z" />
                </svg>
              </div>
              <div class="volume">
                <span class="volume-icon" style="display: flex;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-volume2-icon lucide-volume-2">
                    <path
                      d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z" />
                    <path d="M16 9a5 5 0 0 1 0 6" />
                    <path d="M19.364 18.364a9 9 0 0 0 0-12.728" />
                  </svg>
                </span>
                <span class="mute-icon" style="display: none;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-volume-off-icon lucide-volume-off">
                    <path d="M16 9a5 5 0 0 1 .95 2.293" />
                    <path d="M19.364 5.636a9 9 0 0 1 1.889 9.96" />
                    <path d="m2 2 20 20" />
                    <path
                      d="m7 7-.587.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298V11" />
                    <path d="M9.828 4.172A.686.686 0 0 1 11 4.657v.686" />
                  </svg>
                </span>
              </div>
            </div>
          </div>
          <div data-attribute="item" class="swiper-slide">
            <div class="wrap-item">
              <video loop playsinline width="600">
                <source data-attribute="card-video"
                  src="https://hizoo.co/cdn/shop/videos/c/vp/29e75bdc53e1422f979b4790612ecaa2/29e75bdc53e1422f979b4790612ecaa2.HD-1080p-2.5Mbps-57703803.mp4?v=0"
                  type="video/mp4">
              </video>
              <div data-attribute="playvideo" data-background="#d4c4a8" data-color="#FFFFFF"
                style="background-color: #d4c4a8; color: #FFFFFF;" class="playvideo">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="lucide lucide-play-icon lucide-play">
                  <path d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z" />
                </svg>
              </div>
              <div class="volume">
                <span class="volume-icon" style="display: flex;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-volume2-icon lucide-volume-2">
                    <path
                      d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z" />
                    <path d="M16 9a5 5 0 0 1 0 6" />
                    <path d="M19.364 18.364a9 9 0 0 0 0-12.728" />
                  </svg>
                </span>
                <span class="mute-icon" style="display: none;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-volume-off-icon lucide-volume-off">
                    <path d="M16 9a5 5 0 0 1 .95 2.293" />
                    <path d="M19.364 5.636a9 9 0 0 1 1.889 9.96" />
                    <path d="m2 2 20 20" />
                    <path
                      d="m7 7-.587.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298V11" />
                    <path d="M9.828 4.172A.686.686 0 0 1 11 4.657v.686" />
                  </svg>
                </span>
              </div>
            </div>
          </div>
          <div data-attribute="item" class="swiper-slide">
            <div class="wrap-item">
              <video loop playsinline width="600">
                <source data-attribute="card-video"
                  src="https://hizoo.co/cdn/shop/videos/c/vp/91d481b53cbf4df091f83c9eb1fdb0d1/91d481b53cbf4df091f83c9eb1fdb0d1.HD-1080p-2.5Mbps-57703555.mp4?v=0"
                  type="video/mp4">
              </video>
              <div data-attribute="playvideo" data-background="#d4c4a8" data-color="#FFFFFF"
                style="background-color: #d4c4a8; color: #FFFFFF;" class="playvideo">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="lucide lucide-play-icon lucide-play">
                  <path d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z" />
                </svg>
              </div>
              <div class="volume">
                <span class="volume-icon" style="display: flex;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-volume2-icon lucide-volume-2">
                    <path
                      d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z" />
                    <path d="M16 9a5 5 0 0 1 0 6" />
                    <path d="M19.364 18.364a9 9 0 0 0 0-12.728" />
                  </svg>
                </span>
                <span class="mute-icon" style="display: none;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-volume-off-icon lucide-volume-off">
                    <path d="M16 9a5 5 0 0 1 .95 2.293" />
                    <path d="M19.364 5.636a9 9 0 0 1 1.889 9.96" />
                    <path d="m2 2 20 20" />
                    <path
                      d="m7 7-.587.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298V11" />
                    <path d="M9.828 4.172A.686.686 0 0 1 11 4.657v.686" />
                  </svg>
                </span>
              </div>
            </div>
          </div>
          <div data-attribute="item" class="swiper-slide">
            <div class="wrap-item">
              <video loop playsinline width="600">
                <source data-attribute="card-video"
                  src="https://hizoo.co/cdn/shop/videos/c/vp/a2a32c843e1642eeb3e524e944d50512/a2a32c843e1642eeb3e524e944d50512.HD-1080p-2.5Mbps-57703553.mp4?v=0"
                  type="video/mp4">
              </video>
              <div data-attribute="playvideo" data-background="#d4c4a8" data-color="#FFFFFF"
                style="background-color: #d4c4a8; color: #FFFFFF;" class="playvideo">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="lucide lucide-play-icon lucide-play">
                  <path d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z" />
                </svg>
              </div>
              <div class="volume">
                <span class="volume-icon" style="display: flex;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-volume2-icon lucide-volume-2">
                    <path
                      d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z" />
                    <path d="M16 9a5 5 0 0 1 0 6" />
                    <path d="M19.364 18.364a9 9 0 0 0 0-12.728" />
                  </svg>
                </span>
                <span class="mute-icon" style="display: none;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-volume-off-icon lucide-volume-off">
                    <path d="M16 9a5 5 0 0 1 .95 2.293" />
                    <path d="M19.364 5.636a9 9 0 0 1 1.889 9.96" />
                    <path d="m2 2 20 20" />
                    <path
                      d="m7 7-.587.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298V11" />
                    <path d="M9.828 4.172A.686.686 0 0 1 11 4.657v.686" />
                  </svg>
                </span>
              </div>
            </div>
          </div>
          <div data-attribute="item" class="swiper-slide">
            <div class="wrap-item">
              <video loop playsinline width="600">
                <source data-attribute="card-video"
                  src="https://hizoo.co/cdn/shop/videos/c/vp/e1cad5ac90d64cc9ae31a3f1efcc6915/e1cad5ac90d64cc9ae31a3f1efcc6915.HD-720p-1.6Mbps-57703554.mp4?v=0"
                  type="video/mp4">
              </video>
              <div data-attribute="playvideo" data-background="#d4c4a8" data-color="#FFFFFF"
                style="background-color: #d4c4a8; color: #FFFFFF;" class="playvideo">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="lucide lucide-play-icon lucide-play">
                  <path d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z" />
                </svg>
              </div>
              <div class="volume">
                <span class="volume-icon" style="display: flex;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-volume2-icon lucide-volume-2">
                    <path
                      d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z" />
                    <path d="M16 9a5 5 0 0 1 0 6" />
                    <path d="M19.364 18.364a9 9 0 0 0 0-12.728" />
                  </svg>
                </span>
                <span class="mute-icon" style="display: none;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-volume-off-icon lucide-volume-off">
                    <path d="M16 9a5 5 0 0 1 .95 2.293" />
                    <path d="M19.364 5.636a9 9 0 0 1 1.889 9.96" />
                    <path d="m2 2 20 20" />
                    <path
                      d="m7 7-.587.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298V11" />
                    <path d="M9.828 4.172A.686.686 0 0 1 11 4.657v.686" />
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="button-next next-unique-id">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="lucide lucide-chevron-right-icon lucide-chevron-right">
            <path d="m9 18 6-6-6-6" />
          </svg>
        </div>
        <div class="button-prev prev-unique-id">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="lucide lucide-chevron-left-icon lucide-chevron-left">
            <path d="m15 18-6-6 6-6" />
          </svg>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
